<template>
  <el-select
    class="group-select"
    value-key="id"
    :value="value || []"
    filterable
    clearable
    multiple
    placeholder="เลือกทั้งหมด"
    @input="$emit('input', $event)"
  >
    <el-option
      v-for="group in groups"
      :key="group.id"
      :label="group.name"
      :value="group"
    ></el-option>
  </el-select>
</template>

<script>
import { Select, Option } from "element-ui";
import { GroupUseCase } from "@/usecases/GroupUseCase";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: ["value"],
  data() {
    return {
      groups: []
    };
  },
  created() {
    this.setupGroups();
  },
  methods: {
    async setupGroups() {
      const allGroups = await GroupUseCase.list();
      // Phase 1: Allow only PackRakPob and RJB2B
      const allowedNames = ["แพ็กแรกพบ", "RJB2B"];
      this.groups = allGroups.filter(g => allowedNames.includes(g.name));
    }
  }
};
</script>

<style lang="scss" scoped>
.group-select {
  width: 100%;
}
</style>
